import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";

import { useRooFeatureFlagVariantKey } from "../../../Common/Wrappers/useRooFeatureFlagEnabled";
import { FEATURE_FLAGS, FEATURE_FLAG_VARIANTS } from "../../../constants/postHogFeatureFlags";
import { useAppSelector } from "../../../store/service";
import { Event, EventTracker } from "../../../tracking/service/EventTracker/EventTrackerService";
import { useProgressPercentEffect } from "../Common/hooks/useProgressPercentEffect";
import { useRedirect } from "../Common/hooks/useRedirect";
import { useRegistrationContext } from "../Common/registrationContext";
import { useRegistrationReferralForm } from "../Common/registrationState";
import { REGISTRATION_PROGRESS_PERCENT } from "../Common/service";
import { RegistrationPageContainer } from "../RegistrationPageContainer/RegistrationPageContainer";

import { RegistrationReferralForm } from "./RegistrationReferralForm";
import { FormProvider } from "./RegistrationReferralFormContext";
import { useSave, useValidate } from "./service";

const RegistrationReferral = () => {
  const defaultForm = useRegistrationReferralForm();
  useProgressPercentEffect(REGISTRATION_PROGRESS_PERCENT.Referral);

  const { save } = useSave();
  const { validate } = useValidate();
  const {
    registrationContext: { entityId, hearAboutRoo },
  } = useRegistrationContext();

  const { redirectToVetHomepage } = useRedirect();
  const isSessionInfoFetched = useAppSelector(({ login }) => login.isSessionInfoFetched);

  const shiftSearchPreferencesVariant = useRooFeatureFlagVariantKey(
    FEATURE_FLAGS.SHIFT_SEARCH_PREFERENCES
  );

  useEffect(() => {
    if (isSessionInfoFetched && hearAboutRoo) {
      redirectToVetHomepage(shiftSearchPreferencesVariant === FEATURE_FLAG_VARIANTS.TEST);
    }
  }, [isSessionInfoFetched, hearAboutRoo]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    EventTracker.send({
      eventName: Event.Name.VET_VIEW_SOURCE,
      eventType: Event.Type.PAGE_VIEW,
      entityType: Event.Entity.VET,
      entityId: entityId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RegistrationPageContainer title="How Did You Hear About Us?">
      <FormProvider defaultForm={defaultForm} save={save} validate={validate}>
        <RegistrationReferralForm />
      </FormProvider>
    </RegistrationPageContainer>
  );
};

// eslint-disable-next-line no-restricted-exports
export default withRouter(RegistrationReferral);
